module.exports = __webpack_public_path__ + "media/app/assets/navIcons/rbg-122a66ff26244e0de48dda14df20b71c.png";